// eslint-disable-next-line import/prefer-default-export
export const filteredCategories = ['Project info', 'Red Flags', 'Study Parameters'];
